<template>
  <div v-if="pendingSiteUsers.length" class="admin-panel">
    <button type="button" class="admin-panel__trigger" @click="isOpen = !isOpen">
      <i class="bi bi-person-check-fill"></i> {{ pendingSiteUsers.length }} waiting for approval
    </button>
    <div v-if="isOpen" class="admin-panel__list">
      <div v-for="u in pendingSiteUsers" :key="u.uid" class="admin-panel__row">
        <div class="admin-panel__who">
          <div class="admin-panel__name">{{ u.displayName || u.email }}</div>
          <div class="admin-panel__email">{{ u.email }}</div>
        </div>
        <div class="admin-panel__actions">
          <button type="button" class="btn btn-sm btn-success" @click="approve(u.uid)">Approve</button>
          <button type="button" class="btn btn-sm btn-outline-danger" @click="deny(u.uid)">Deny</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Matt: "I'd like to get an email or some kind of prompt when somebody
// asks to join, and then I can just[...] allow them, and it'll let them
// in right away." No Firebase project on the paid (Blaze) plan yet, so
// there's no Cloud Function to actually SEND an email - this banner (any
// approved admin, on either game, sees it the moment they open the app)
// is the "some kind of prompt" half of that ask; approving/denying here
// is instant (see store/siteAccess.js - the approved user's own
// watchSiteUserStatus listener picks it up live, no refresh needed on
// their end either). See CLAUDE.md's "Firebase" section for what real
// email notifications would need.
import { mapGetters } from 'vuex';

export default {
  name: 'AdminPanel',
  data() {
    return { isOpen: false };
  },
  computed: {
    ...mapGetters(['pendingSiteUsers']),
  },
  methods: {
    approve(uid) {
      this.$store.dispatch('approveSiteUser', uid);
    },
    deny(uid) {
      this.$store.dispatch('denySiteUser', uid);
    },
  },
};
</script>

<style scoped>
.admin-panel {
  position: fixed;
  top: 0.75rem;
  right: 1rem;
  z-index: 900;
}

.admin-panel__trigger {
  background: linear-gradient(160deg, #d4a017, #a87d0f);
  color: #1b140d;
  font-weight: 700;
  border: none;
  border-radius: 0.4rem;
  padding: 0.4rem 0.7rem;
  font-size: 0.85rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  cursor: pointer;
}

.admin-panel__list {
  margin-top: 0.4rem;
  background: linear-gradient(160deg, #2e2416, #1b140d);
  border: 2px solid #d4a017;
  border-radius: 0.5rem;
  padding: 0.6rem;
  min-width: 260px;
  max-height: 60vh;
  overflow-y: auto;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);
}

.admin-panel__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0;
  border-bottom: 1px solid #3a2f1e;
}

.admin-panel__row:last-child {
  border-bottom: none;
}

.admin-panel__name {
  color: #f4ecd8;
  font-weight: 600;
  font-size: 0.85rem;
}

.admin-panel__email {
  color: #b8a888;
  font-size: 0.72rem;
}

.admin-panel__actions {
  display: flex;
  gap: 0.3rem;
  flex-shrink: 0;
}
</style>
